import React, { useState, useEffect, useCallback, useRef, memo } from "react";
import {
  Dialog,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Grid,
  Avatar,
  useTheme,
  Menu,
  MenuItem,
  Divider,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SortIcon from "@mui/icons-material/Sort";
import SearchDialog from ".";
import { DOMAIN } from "../../config";
import { motion, AnimatePresence } from "framer-motion";
import theme from '../../styles/theme'
import { useMediaQuery} from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const platformGradients = [
  "linear-gradient(135deg, #FF9A9E 0%, #FAD0C4 100%)",
  "linear-gradient(135deg, #F6D365 0%, #FDA085 100%)",
  "linear-gradient(135deg, #A1C4FD 0%, #C2E9FB 100%)",
  "linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)",
  "linear-gradient(135deg, #fccb90 0%, #d57eeb 100%)",
];

const typeGradients = [
  "linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)",
  "linear-gradient(135deg, #42E695 0%, #3BB2B8 100%)",
  "linear-gradient(135deg, #4776E6 0%, #8E54E9 100%)",
  "linear-gradient(135deg, #F7971E 0%, #FFD200 100%)",
  "linear-gradient(135deg, #00C9FF 0%, #92FE9D 100%)",
  "linear-gradient(135deg, #FF9A9E 0%, #FAD0C4 100%)",
];
//{ id: "2", title: "动物世界", subtitle: "爱犬系列，寂寞少妇与爱犬的私密生活" },
const sampleData = [
  { id: "1", title: "淫妻绿帽", subtitle: "放纵自己的妻子与其他男人发生关系" },
  { id: "3", title: "换妻", subtitle: "互相交换伴侣进行亲密性行为" },
  { id: "4", title: "SPA", subtitle: "性爱与按摩的完美结合，极度放松的题材" },
  { id: "5", title: "刷锅", subtitle: "一名女性被内射后，继续和另一名男性性交" },
  { id: "6", title: "内射", subtitle: "男性在女性体内完成射精" },
  { id: "7", title: "灌精", subtitle: "多名男性在一名女性体内完成射精" },
  { id: "8", title: "媚黑", subtitle: "对黑人男性的多元化伴侣体验" },
  { id: "9", title: "双龙入洞", subtitle: "两条（男性）“龙”同时进入一个“洞”" },
  { id: "10", title: "野战", subtitle: "在户外、公共场所或非传统房间环境进行性行为" },
  { id: "11", title: "熟女", subtitle: "气质成熟的女性，性感或情感经验丰富" },
  { id: "12", title: "萝莉", subtitle: "外表年轻、娇小、稚气的女性角色" },
  { id: "13", title: "SM", subtitle: "心理满足、信任与控制，而不仅仅是身体层面的内容" },
  { id: "14", title: "三级", subtitle: "影片内容只适合18岁或以上的成年人观看" },
  { id: "15", title: "颜值", subtitle: "长的很漂亮的女主们" },
  { id: "16", title: "肉便器系列", subtitle: "那些成为男性们精液发泄工具的女优们" },
];

const BlogerCard = memo(({ item, index, tabIndex, handleOpenSearch }) => (
  <Box
    onClick={() => handleOpenSearch(item.bloger || item.title)}
    sx={{
      width: 140,
      height: 200,
      borderRadius: 3,
      bgcolor: "rgba(255,255,255,0.15)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      p: 2,
      cursor: "pointer",
      transition: "all 0.3s ease",
      position: "relative",
      "&:hover": {
        transform: "translateY(-6px) scale(1.05)",
        boxShadow: "0 12px 24px rgba(0,0,0,0.2)",
      },
    }}
  >
    {item.type && (
      <Box
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          px: 1.2,
          py: 0.3,
          borderRadius: 8,
          fontSize: 11,
          fontWeight: 600,
          color: "#fff",
          background: typeGradients[index % typeGradients.length],
          whiteSpace: "nowrap",
          textAlign: "center",
          maxWidth: "60px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          zIndex: 2,
        }}
      >
        {item.type.slice(0, 2)}
      </Box>
    )}
    {item.platform && (
      <Box
        sx={{
          position: "absolute",
          bottom: 8,
          left: 8,
          px: 1.5,
          py: 0.4,
          borderRadius: 10,
          fontSize: 10,
          fontWeight: 500,
          color: "#fff",
          background: platformGradients[index % platformGradients.length],
          whiteSpace: "nowrap",
          textAlign: "center",
          maxWidth: "80px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          zIndex: 2,
        }}
      >
        {item.platform}
        {tabIndex === 1 ? "博主" : ""}
      </Box>
    )}
    <Avatar sx={{ width: 80, height: 80, mb: 1 }}>
  <img
    src={`${DOMAIN}miniapp/${item.img_url}.tb.jpg`}
    alt={item.bloger}
    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
    onError={(e) => {
      e.target.onerror = null;
      e.target.src = `${DOMAIN}miniapp/${item.img_url}.jpg`;
    }}
  />
</Avatar>
    <Typography
      variant="subtitle1"
      sx={{
        fontWeight: 700,
        textAlign: "center",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {item.bloger}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        textAlign: "center",
        mt: 0.3,
        opacity: 0.75,
        fontSize: 12,
        display: "-webkit-box",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
      }}
    >
      {item.caption}
    </Typography>
  </Box>
));

export default function TextCategoryDialog({ open, setOpenType, categories = sampleData }) {
  const theme = useTheme();
  const [openSearch, setOpenSearch] = useState(false);
  const [chipTitle, setChipTitle] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [blogers, setBlogers] = useState({ 1: [], 2: [] });
  const [page, setPage] = useState({ 1: 1, 2: 1 });
  const [hasMore, setHasMore] = useState({ 1: true, 2: true });
  const [loading, setLoading] = useState(false);
  const pageSizeConfig = { 1: 6, 2: 10 };
  const fetchedPagesRef = useRef({ 1: new Set(), 2: new Set() });
  const loadMoreRef = useRef(null);
  const [typeFilter, setTypeFilter] = useState("");
  const [platformFilter, setPlatformFilter] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const tabs = [
    { key: "type", label: "视频类型" },
    { key: "popular", label: "热门博主" },
    { key: "series", label: "系列全集" },
  ];

  const typeOptions = ["夜未央", "推特", "onlyfans", "fansone", "海角社区"];
  const platformOptions = ["淫妻", "媚黑", "露出", "调教", "探花", "颜值", "乱伦", "丝袜"];

  const handleOpenSearch = (text) => {
    setChipTitle(text);
    setOpenSearch(true);
  };

  const handleChange = (index) => {
    setTabIndex(index);
    // 切换 Tab 时清除 Chip 和筛选条件
    setChipTitle(null);
    setTypeFilter("");
    setPlatformFilter("");
    fetchedPagesRef.current[1] = new Set();
    setPage(prev => ({ ...prev, 1: 1 }));
    setBlogers(prev => ({ ...prev, 1: [] }));
    setHasMore(prev => ({ ...prev, 1: true }));
  };
  
  const handleSortClick = (event) => setAnchorEl(event.currentTarget);
  const handleSortClose = () => setAnchorEl(null);

  const handleTypeSelect = (type) => {
    setTypeFilter(type === "全部" ? "" : type);
    setPlatformFilter(""); 
    setChipTitle(type === "全部" ? null : type);
    fetchedPagesRef.current[1] = new Set();
    setPage(prev => ({ ...prev, 1: 1 }));
    setBlogers(prev => ({ ...prev, 1: [] }));
    setHasMore(prev => ({ ...prev, 1: true }));
    handleSortClose();
  };

  const handlePlatformSelect = (platform) => {
    setPlatformFilter(platform === "全部" ? "" : platform);
    setTypeFilter(""); 
    setChipTitle(platform === "全部" ? null : platform);
    fetchedPagesRef.current[1] = new Set();
    setPage(prev => ({ ...prev, 1: 1 }));
    setBlogers(prev => ({ ...prev, 1: [] }));
    setHasMore(prev => ({ ...prev, 1: true }));
    handleSortClose();
  };

  const handleChipDelete = () => {
    setTypeFilter("");
    setPlatformFilter("");
    setChipTitle(null);
    fetchedPagesRef.current[1] = new Set();
    setPage(prev => ({ ...prev, 1: 1 }));
    setBlogers(prev => ({ ...prev, 1: [] }));
    setHasMore(prev => ({ ...prev, 1: true }));
  };

  const fetchBlogers = useCallback(async (tab) => {
    if (loading) return;
    if (fetchedPagesRef.current[tab].has(page[tab])) return;
    fetchedPagesRef.current[tab].add(page[tab]);
    setLoading(true);

    try {
      const tabPageSize = pageSizeConfig[tab] || 6;
      let url = `${DOMAIN}ywyblogerbot/getBlogers?page=${page[tab]}&pageSize=${tabPageSize}&tab=${tab}`;
      if (tab === 1) {
        if (typeFilter) url += `&type=${encodeURIComponent(typeFilter.trim())}`;
        if (platformFilter) url += `&platform=${encodeURIComponent(platformFilter.trim())}`;
      }

      const res = await fetch(url);
      const data = await res.json();

      if (data.success) {
        const newList = data.list || [];
        setBlogers(prev => ({ ...prev, [tab]: [...prev[tab], ...newList] }));
        setHasMore(prev => ({ ...prev, [tab]: newList.length === tabPageSize }));
      }
    } catch (err) {
      console.error("获取博主/系列失败:", err);
    } finally {
      setLoading(false);
    }
  }, [loading, page, typeFilter, platformFilter]);

  useEffect(() => {
    if (tabIndex === 1) {
      fetchedPagesRef.current[1] = new Set();
      setPage(prev => ({ ...prev, 1: 1 }));
      setBlogers(prev => ({ ...prev, 1: [] }));
      setHasMore(prev => ({ ...prev, 1: true }));
      fetchBlogers(1);
    }
  }, [typeFilter, platformFilter, tabIndex]);

  useEffect(() => {
    if (open && [1, 2].includes(tabIndex)) fetchBlogers(tabIndex);
  }, [open, tabIndex, page, fetchBlogers]);

  useEffect(() => {
    if (![1, 2].includes(tabIndex)) return;
    if (!hasMore[tabIndex]) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !loading) {
        setPage(prev => ({ ...prev, [tabIndex]: prev[tabIndex] + 1 }));
      }
    }, { threshold: 0.1 });
    if (loadMoreRef.current) observer.observe(loadMoreRef.current);
    return () => observer.disconnect();
  }, [tabIndex, loading, hasMore[tabIndex]]);

  const onClose = () => setOpenType(false);
  const currentData = tabIndex === 0 ? categories : blogers[tabIndex] || [];

  return (
    <>
      <SearchDialog openSearch={openSearch} setOpenSearch={setOpenSearch} matches={matches} chipTitle={chipTitle} />
      <Dialog
        fullScreen
        open={open}
        onClose={onClose}
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            bgcolor: "background.default",
            background: `linear-gradient(180deg, ${theme.palette.background.paper} 0%, rgba(250,250,255,0.02) 100%)`,
            overflow: "auto",
          },
        }}
      >
        <AppBar position="sticky" elevation={0} sx={{ background: "rgba(255,255,255,0.3)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", boxShadow: "none", borderBottom: "1px solid rgba(255,255,255,0.2)", zIndex: 1200 }}>
        <Toolbar sx={{ px: 2 }}>
  <Typography
    variant="h6"
    sx={{ flex: 1, fontWeight: 700, color: "#000" }}
  >
    分类
  </Typography>

  {/* Sort 按钮动画 */}
  <AnimatePresence>
    {tabIndex === 1 && (
      <motion.div
        initial={{ x: -40, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -40, opacity: 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        <IconButton onClick={handleSortClick}>
          <SortIcon sx={{ color: "#000" }} />
        </IconButton>
      </motion.div>
    )}
  </AnimatePresence>

  {/* Chip 动画 */}
  <AnimatePresence>
    {chipTitle && (
      <motion.div
        initial={{ x: -40, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -40, opacity: 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        <Chip
          label={chipTitle}
          onDelete={handleChipDelete}
          size="small"
          sx={{ ml: 1 }}
        />
      </motion.div>
    )}
  </AnimatePresence>

  <IconButton edge="end" onClick={onClose}>
    <CloseIcon sx={{ color: "#000" }} />
  </IconButton>
</Toolbar>

          <Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleSortClose}
  PaperProps={{
    sx: {
      minWidth: 180,
      bgcolor: "rgba(255, 255, 255, 0.15)",
      backdropFilter: "blur(14px)",
      WebkitBackdropFilter: "blur(14px)",
      color: "text.primary",
      boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
      p: 1.5,
      borderRadius: 2,
    },
  }}
  MenuListProps={{ sx: { py: 0 } }}
>
  {/* 博主类型标题 */}
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      px: 2,
      py: 0.8,
      mb: 0.8,
      fontSize: 13,
      fontWeight: 700,
      color: "#333", // 深色文字
      bgcolor: "rgba(255,255,255,0.05)", // 浅背景
      borderRadius: 2,
      boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
      userSelect: "none",
      gap: 1,
    }}
  >
    <Box sx={{ width: 6, height: 6, bgcolor: "#333", borderRadius: "50%" }} /> 博主平台
  </Box>

  {typeOptions.map(opt => (
    <MenuItem
      key={opt}
      onClick={() => handleTypeSelect(opt)}
      sx={{
        px: 2,
        py: 0.8,
        fontSize: 13,
        borderRadius: 1,
        transition: "all 0.2s ease",
        "&:hover": { bgcolor: "rgba(255,255,255,0.12)" },
      }}
    >
      {opt}
    </MenuItem>
  ))}

  <Divider sx={{ my: 0.5, borderColor: "rgba(255,255,255,0.2)" }} />

  {/* 博主平台标题 */}
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      px: 2,
      py: 0.8,
      mb: 0.8,
      fontSize: 13,
      fontWeight: 700,
      color: "#333", // 深色文字
      bgcolor: "rgba(255,255,255,0.05)",
      borderRadius: 2,
      boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
      userSelect: "none",
      gap: 1,
    }}
  >
    <Box sx={{ width: 6, height: 6, bgcolor: "#333", borderRadius: "50%" }} /> 博主类型
  </Box>

  {platformOptions.map(opt => (
    <MenuItem
      key={opt}
      onClick={() => handlePlatformSelect(opt)}
      sx={{
        px: 2,
        py: 0.8,
        fontSize: 13,
        borderRadius: 1,
        transition: "all 0.2s ease",
        "&:hover": { bgcolor: "rgba(255,255,255,0.12)" },
      }}
    >
      {opt}
    </MenuItem>
  ))}
</Menu>


          <Box sx={{ display: "flex", gap: 1, py: 1, px: 2, position: "sticky", top: 64, background: "transparent", zIndex: 1199, overflowX: "auto" }}>
            {tabs.map((t, index) => {
              const gradients = ["linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)","linear-gradient(135deg, #FFD200 0%, #F7971E 100%)","linear-gradient(135deg, #42E695 0%, #3BB2B8 100%)"];
              const activeGradient = gradients[index % gradients.length];
              return (
                <motion.div key={t.key} onClick={() => handleChange(index)} initial={{ x: -50, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ type: "spring", stiffness: 200, damping: 20, delay: index * 0.05 }} style={{ padding: "6px 12px", minWidth: 60, borderRadius: 14, cursor: "pointer", fontWeight: 700, fontSize: 13, textAlign: "center", color: tabIndex === index ? "#fff" : "#3B3B3B", background: tabIndex === index ? activeGradient : "rgba(255,255,255,0.15)", boxShadow: tabIndex === index ? "0 4px 12px rgba(0, 0, 0, 0.25)" : "none", flexShrink: 0, transition: "all 0.3s ease" }}>{t.label}</motion.div>
              );
            })}
          </Box>
        </AppBar>

        <Box sx={{ p: { xs: 2, sm: 3 }, pb: 6 }}>
          <Grid container spacing={3} justifyContent="center">
            {currentData.map((item, index) => (
              <Grid key={item.id || index} item xs={6} sm={4} md={3} lg={2} sx={{ display: "flex", justifyContent: "center" }}>
                {(tabIndex === 1 || tabIndex === 2) ? (
                  <BlogerCard item={item} index={index} tabIndex={tabIndex} handleOpenSearch={handleOpenSearch} />
                ) : (
                  <Box
                    onClick={() => handleOpenSearch(item.title)}
                    sx={{
                      width: "100%",
                      height: 140,
                      borderRadius: 3,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      px: 2,
                      cursor: "pointer",
                      color: "#fff",
                      background: typeGradients[index % typeGradients.length],
                      transition: "transform .18s ease, box-shadow .18s ease",
                      "&:hover": { transform: "translateY(-4px)", boxShadow: "0 14px 28px rgba(16,24,40,0.2)" }
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{item.title}</Typography>
                    <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>{item.subtitle}</Typography>
                  </Box>
                )}
              </Grid>
            ))}
          </Grid>

          {(tabIndex === 1 || tabIndex === 2) && loading && (
            <Typography sx={{ textAlign: "center", mt: 2 }}>加载中...</Typography>
          )}
          {(tabIndex === 1 || tabIndex === 2) && !hasMore[tabIndex] && !loading && (
            <Typography sx={{ textAlign: "center", mt: 2, color: "gray" }}>没有更多了</Typography>
          )}
          {(tabIndex === 1 || tabIndex === 2) && <div ref={loadMoreRef} style={{ height: 50 }} />}
        </Box>
      </Dialog>
    </>
  );
}
